import React, { Component } from 'react';

class Loading extends Component {
    render() {
        return (
          <div className="page-loading-container">
            <div className="loading loading-green">
            </div>
            <div className="loading-text text-green">
                {/* DOWNLOADING... */}
                파일 준비중...
            </div>
        </div>
        );
    }
}

export default Loading;


// WEBPACK FOOTER //
// ./src/components/modal/CutLoading.js